import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
      this.initAutocomplete()
    } else {
      window.initMapCallback = () => this.initAutocomplete()
    }
  }

  initAutocomplete() {
    const options = {
      types: ['(cities)'],
      componentRestrictions: { country: "br" },
      fields: ["formatted_address", "geometry", "name"],
    }
    this.autocomplete = new google.maps.places.Autocomplete(this.inputTarget, options)
    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace()
      // Optionally auto-submit: this.inputTarget.form.submit()
      console.log("Selected:", place.name)
    })
  }
}
